/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BackspaceIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABSUlEQVR4nO2VvU7DQAzHMyFWZiTWDrQSQrAwAGK9+CPDnU2WiqehgrfiCWDgBVD5SBZWBmhRUhJBSXKhIVstWTnllN/fsX2+IFhbFwOWEFnugPQdWedtHFgekXVird3wwPUcWWdtwRU+qYUTySmyvnWAz5H0uRJuIjcEltdOcF74L3gY2h1kna4InDUKGBNvAet9E4RIjsLIHQJJUhaVJCGK9xDtAEg+KgVOxuNNYL3xRRlGbr9MYy4iLwC6m71D1IPaP0DW61YtSJIUwOxZrIniEZKm9QIVm00iJnLD8lu0g6xjGov8Pact2i9dFgCSJ4+AXrWFE8Wj5RTl64og/1xkiPSsAOYFXnRQLojojju3KaK7yEA/oiVNM+F8z3fQjLHbwPqw4kGbewXKfPY1Kv512LFOgz7HNZBeBj7DSA2S3vZy4awt+LJPX61y3mRX2zsAAAAASUVORK5CYII=)
 */
export const BackspaceIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M9.35 3A3 3 0 0 0 7.1 4l-5.34 6a3 3 0 0 0 0 4l5.34 6a3 3 0 0 0 2.24 1H20a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H9.35Zm1.94 5.3a1 1 0 0 1 1.42 0L15 10.58l2.3-2.3a1 1 0 1 1 1.4 1.42L16.42 12l2.3 2.3a1 1 0 0 1-1.42 1.4L15 13.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L13.58 12l-2.3-2.3a1 1 0 0 1 0-1.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
